import { FETCH_IMAGE_NAMES, FETCH_IMAGE_NAMES_FAILURE, FETCH_IMAGE_NAMES_SUCCESS } from "../actions/image.action";

const initialState = {
    loading: false,
    images: [],
    error: ''
};

const imageReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_IMAGE_NAMES:
            console.log('state', state);
            return {
                ...state,
                loading: true,
            };
        case FETCH_IMAGE_NAMES_SUCCESS:
            console.log(`${action.info}`, state);

            const { data } = action.payload;
            return {
                ...state,
                images: data,
                loading: false,
            }
        case FETCH_IMAGE_NAMES_FAILURE:
            console.log('state', state);

            const { error } = action.payload;
            return {
                ...state,
                error,
                loading: false,
            }
        default: return state;
    }
}

export default imageReducer;
